import { CsvParseResult } from '../models/csv-parser.model';

const NEW_LINE_REGEX = /\r\n|\n/;
const NEW_LINE_AT_END_OF_INPUT = /[\r|\n]+$/;
const FIELD_DELIMITER = ';';

export const COLUMN_INDEXES = {
  CUSTOMER_NUMBER: 0,
  CHARGED_NUMBER: 4,
  CALL_ORIGIN: 6,
  CALLED_NUMBER: 7,
  DESTINATION: 8,
  CALL_CATEGORY: 9,
  CALL_TYPE: 10,
  DATE: 11,
  START_TIME: 12,
  DURATION: 13,
  AMOUNT: 15,
};

export function parseCsvFile(csv: string): CsvParseResult {
  const rows = csv
    // remove trailing EOL if any
    .replace(NEW_LINE_AT_END_OF_INPUT, '')
    .split(NEW_LINE_REGEX)
    .slice(1) // Note: To not process headers row
    .map((row) => row.split(FIELD_DELIMITER));

  if (rows.length === 0) {
    return { hasError: true };
  }

  const phoneNumbers = getUniqueDefinedColumnValues(
    rows,
    COLUMN_INDEXES.CHARGED_NUMBER
  );
  if (phoneNumbers.length === 0 && rows.length === 1) {
    return { hasError: true };
  }

  const callCategories = getUniqueDefinedColumnValues(
    rows,
    COLUMN_INDEXES.CALL_CATEGORY
  );
  const dates = getUniqueDefinedColumnValues(rows, COLUMN_INDEXES.DATE);

  return { rows, phoneNumbers, callCategories, dates, hasError: false };
}

function getUniqueDefinedColumnValues(
  rows: Array<Array<string>>,
  columnIndex: number
): Array<string> {
  return [...new Set(rows.map((row) => row[columnIndex]))]
    .filter((a) => a)
    .map((value) => value.replace(/^'|'$/g, '')); // Note: removes leading or trailing single quote char
}
